import { env } from '../config/env';
import { useArWarmStatus } from '../ar';

/**
 * A small dot in the top-left corner while the AR engine is not ready.
 *
 * Deliberately tiny and unlabelled. On a 49" panel an operator who knows to look
 * cannot miss it, and a guest queueing for a photo booth will never notice it —
 * which is the right trade for something that is only actionable by staff.
 *
 * It sits in the same corner as the web admin gesture on purpose: the dot is the
 * prompt, and three taps on it is the way in to the AR section that explains it.
 * `pointer-events-none` so it never eats one of those taps.
 *
 * Nothing renders once the engine is ready, which is the normal state.
 */
export function ArReadyDot() {
  const warm = useArWarmStatus();

  if (env.arModule !== 'camera-kit') return null;
  if (warm.state === 'ready') return null;

  // Amber while it is still trying, red once an attempt has actually failed —
  // so "starting up" and "this needs you" look different from across a lobby.
  const failed = warm.state === 'failed';

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed left-3 top-3 z-[90] h-3 w-3 rounded-full"
      style={{
        backgroundColor: failed ? '#B5281E' : '#AB986F',
        boxShadow: failed ? '0 0 8px #B5281E' : 'none',
      }}
    />
  );
}
